let language = {
    "privacy:InformationCollect": "What information do we collect from you?",
    "privacy:Collected": "Who is collecting it and how is it collected?",
    "privacy:Log": "Log Files",
    "privacy:DataUsed": "Why is it being collected and how will it be used?",
    "privacy:GoogleIntegrated": "Information from integrated services like Google:",
    "privacy:Shared": "Who will it be shared with?",
    "privacy:Storage": "Local Storage Objects (Flash and HTML5)",
    "privacy:Security": "Security",
    "privacy:AddtionalInformation": "Additional Information",
    "privacy:ChildrenPrivacy": "Children's Privacy",
    "privacy:ChangePolicy": "Changes To This Policy",
    "privacy:UserChoice": "User Access and Choice",
    "privacy:ContactUs": "Contact Us",
    "privacy:ContactWriting": "When you contact us in writing",
    "privacy:Affiliates": "For Affiliates: What we collect and store",
    "privacy:Access": "Who on our team has access",
};

export { language }